import { type Action, type ThunkDispatch } from '@reduxjs/toolkit';

import { NftMintSteps, type ResourceId } from '@app/client';
import { getOpenSeaMintedYatUrl } from '@app/helpers';

import { type RootState } from '../reducers';
import {
    ACTION_NFT_MINT_PANEL_STEP,
    ACTION_SET_LIQUID_ID_COLLECTION_ID,
    ACTION_SET_NFT_PANEL_OPEN,
    ACTION_SET_OPENSEA_URL,
    type NftActionTypes,
} from '../types/nft';
// eslint-disable-next-line import/no-cycle
import { useEmojisStore } from '../zustand/emojis/useEmojisStore';

export const setLiquidIdCollectionId = (liquidIdCollectionId: ResourceId): NftActionTypes => ({
    type: ACTION_SET_LIQUID_ID_COLLECTION_ID,
    liquidIdCollectionId,
});

export const setNftPanelOpen = (nftPanelOpen: boolean): NftActionTypes => ({
    type: ACTION_SET_NFT_PANEL_OPEN,
    nftPanelOpen,
});

export const setNftMintPanelStep = (nftMintPanelStep: NftMintSteps | null): NftActionTypes => ({
    type: ACTION_NFT_MINT_PANEL_STEP,
    nftMintPanelStep,
});

export const setOpenSeaUrl = (openSeaUrl: string | null): NftActionTypes => ({
    type: ACTION_SET_OPENSEA_URL,
    openSeaUrl,
});

export const openNftPanel = (nftMintPanelStep?: NftMintSteps) => {
    return async function (dispatch: ThunkDispatch<RootState, void, Action>): Promise<void> {
        if (nftMintPanelStep) {
            dispatch(setNftMintPanelStep(nftMintPanelStep));
        }
        dispatch(setNftPanelOpen(true));
    };
};

export const loadCurrentEmojiOpenSeaUrl = () => {
    return async function (dispatch: ThunkDispatch<RootState, void, Action>): Promise<void> {
        const currentEmojiTokenId = useEmojisStore.getState().currentEmojiTokenId;
        const url = getOpenSeaMintedYatUrl(currentEmojiTokenId);
        if (url) {
            dispatch(setOpenSeaUrl(url));
        }
    };
};

export const openRenameYatSidePanel = () => {
    return async function (dispatch: ThunkDispatch<RootState, void, Action>): Promise<void> {
        dispatch(setNftMintPanelStep(NftMintSteps.RenameNft));
        dispatch(setNftPanelOpen(true));
    };
};
